"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* [DISABLED_TEMPORARILY] @ typescript-eslint /camelcase */
var staticNavigationConfig = [
    {
        key: 'title',
        type: 'string',
        label_ar: 'Title',
        label_en: 'Title',
        required: true,
    },
    {
        key: 'sectionLinks',
        type: 'array',
        label_ar: 'Section Links',
        label_en: 'Section Links',
        required: true,
        values: [
            {
                key: 'linkText',
                type: 'string',
                label_ar: 'Link Text',
                label_en: 'Link Text',
                required: true,
            },
            {
                key: 'linkUrl',
                type: 'url',
                label_ar: 'Link Url',
                label_en: 'Link Url',
                required: true,
            },
        ],
        is_virtual: false,
    },
    // Virtual as no use for this yet as not looking into analysis
    {
        key: 'widgetId',
        type: 'number',
        label_ar: 'Widget ID',
        label_en: 'Widget ID',
        required: false,
        is_virtual: true,
    },
];
exports.default = staticNavigationConfig;
//# sourceMappingURL=config.js.map